import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        marginEnd: "auto"
    },
    text: {
        fontVariant: [
            "tabular-nums"
        ]
    }
});
export default stylesheet;
